<template>
  <div class="card">
    <img
      @click.prevent="showRestaurant"
      :src="require(`../assets/restaurantPhotos/${restaurant.photo}.jpeg`)"
      alt="Could
    Not Find"
    />
    <div class="info">
      <h4>{{ restaurant.name }}</h4>
      <h6>Location : {{ restaurant.location }}</h6>
      <!--
      <router-link @click="showRestaurant" class="link" to="#">
        View The Restaurant <Arrow class="arrow" />
      </router-link>
      -->
      <button class="card-button" @click.prevent="showRestaurant">
        Visit The Restaurant <Arrow class="arrow" />
      </button>
    </div>
  </div>
</template>

<script>
import Arrow from "../assets/Icons/arrow-right-light.svg";

export default {
  name: "CardView",
  components: {
    Arrow,
  },
  props: ["restaurant"],
  methods: {
    showRestaurant() {
      this.$emit("show-restaurant", this.restaurant);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  cursor: pointer;
  display: flex;
  border-radius: 8px;
  flex-direction: column;
  min-height: 420px;
  background-color: #fff;
  transition: 0.5s ease all;

  &:hover {
    transform: rotateZ(1deg) scale(1.03);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  img {
    display: block;
    border-radius: 8px 8px 0 0;
    width: 100%;
    min-height: 200px;
    object-fit: cover;
    z-index: 1;
  }

  .info {
    display: flex;
    flex-direction: column;
    height: 100%;
    z-index: 3;
    padding: 32px 16px;
    color: #000;

    .card-button {
      transition: 0.5s ease-in all;
      font-size: 12px;
      align-items: center;
      text-align: left;
      border-radius: 8px;
      color: #000;
      background-color: #fff;
      width: 60%;
      border: none;
      cursor: pointer;

      &:hover {
        color: rgba(48, 48, 48, 0.8);
      }

      .arrow {
        width: 10px;
      }
    }

    h4 {
      padding-bottom: 8px;
      font-size: 20px;
      font-weight: 300;
    }

    h6 {
      font-weight: 400;
      font-size: 12px;
      padding-bottom: 16px;
    }

    .link {
      display: inline-flex;
      margin-top: auto;
      align-items: center;
      font-weight: 500;
      padding-top: 20px;
      font-size: 12px;
      padding-bottom: 4px;
      transition: 0.5s ease-in all;

      &:hover {
        color: rgba(48, 48, 48, 0.8);
      }

      .arrow {
        width: 10px;
      }
    }
  }
}
</style>
